module.exports = __webpack_public_path__ + "static/media/featureNew.66bf7990.svg";